import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'
import api from "@/service/api";
import VueI18n from "@/helpers/i18n";

export interface State {
    showSb: boolean,
    width: number | null,
    scrollHeight: number | null,
    appLoaded:boolean
}

const defaultState: State = {
    appLoaded:false,
    showSb: false,
    width: null,
    scrollHeight: 0
}

const getters = {
    GetScrollHeight(state: State) {
        return state.scrollHeight
    },
    GetShowSb(state: State): Boolean {
        return state.showSb
    },
    GetWidth(state: State) {
        return state.width
    },
    appLoaded(state: State) {
        return state.appLoaded
    }
}

const mutations: MutationTree<State> = {
    setAppLoaded(state: State, payload:boolean): any {
        state.appLoaded = payload
    },
    setScrollHeight(state: State, payload: number | null): any {
        state.scrollHeight = payload
    },
    SetShowSb(state: State, payload: boolean): void {
        state.showSb = payload
    },
    SetShowSbToggle(state: State, payload): void {
        state.showSb = payload
    },
    SetWidth(state: State, payload: number | null): void {
        state.width = payload
    }
}

const actions: ActionTree<State, RootState> = {
    async sendMailToSupport({commit}, payload) {
        try {
            const data = await api.go('sendSupport', {body: payload})
            this.commit('alerts/setAlert', {
                messages: [VueI18n.t('support.message')]
            })
        } catch (error) {
            this.commit('alerts/setAlert', {
                messages: [error]
            })
        }
    }
}

export default {
    namespaced: true,
    state: defaultState,
    getters,
    mutations,
    actions,
};
